import React from "react";
import "../App.css"
import img3 from "../images/img-3.png"
import first from "../images/a.png"
import second from "../images/b.png"
import third from "../images/c.png"
import forth from "../images/d.png"
import JoinButton from "./JoinButton";


function Promise() {
    return (
        <div className="promiseBg">
            <div className="container">
                <div className="freespacepromise"></div>
                <div className="row ourcomicbook pt-3" id="about">
                    <div className="col-md-6">
                        <img className="w-100 ml-4 img3" src={img3}></img>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-5 comicText">
                        <p>Our comic book series delves into a vast and captivating world of storytelling and lore,
                            guaranteed to captivate and excite readers. Our community members and alpha holders are
                            instrumental in shaping the ecosystem and driving future projects. Moreover, each ARTAXIA
                            NFT serves as a vital key to unlock the next set of projects.
                        </p>
                    </div>

                </div>
                <div className="row" id="promise">
                    <div className="col-md-12 text-center pt-5 mt-5">
                        <h2 className="promise">Promises</h2>
                    </div>
                </div>
                <div className="row pt-5 mt-5 abc">
                    <div className="ourpromise">
                        <p className="">Two projects within one <br /> month of each other, expanding<br /> our lore and introducing new<br /> characters.
                            These projects include<br /> our Nemesis collection and <br /> a yet-to-be-announced project</p>
                    </div>
                    <div className="ourpromise">
                        <p className="">Regular monthly releases of new <br /> comic pages, leading up to the <br /> full book’s completion.</p>
                    </div>
                    <div className="ourpromise">
                        <p className="">The creation of a true family <br /> of holders, where members can<br /> connect, support each other <br />  and thrive together.</p>
                    </div>
                </div>
                <div className="row pt-5 mt-3 abc">
                    <div className="ourpromise">
                        <p className="">Exceptional and high-quality <br /> art offered at an  affordable <br /> price.</p>
                    </div>
                    <div className="ourpromise">
                        {/* <p className="">A dedicated founder and team <br /> who engage daily with his  community,  providing transparency <br /> every step   of the  way.</p> */}
                        <p className="">
                            A dedicated founder and team who <br />
                            engage daily with their community,<br />
                            providing transparency every step<br />
                            of the way. We will always be here<br />
                            for you and we will always engage<br />
                            in fun and innovative ways.
                        </p>
                    </div>
                    <div className="ourpromise">
                        <p className="">0 initial royalties, ensuring that <br /> our community members can <br /> profit from their investments.</p>
                    </div>
                </div>


                <div className="freespace"></div>
                <div className="row">
                    <div className="col-md-12 ourNemesis pb-5">



                        {/* <h4><span>Our team</span>  is committed  to transparent communication with our community,
                            ensuring that everyone remains informed and engaged. However, the true star of Project
                            Artaxia is none other than you, our holders and supporters of this incredible community.
                        </h4> */}



                        <h4 className="pt-4"><span>Our Nemesis</span> Collection is set to launch in 3-4 weeks after our initial collection sells out.
                            This collection will dive deeper into the lore and world of ARTAXIA.
                        </h4>


                        <h4 className="pt-4"><span>We invite you</span> to join our community of alpha holders and immerse
                            yourself in the next level of artistry. You will experience the unparalleled quality and creativity
                            that our project has in store.
                        </h4>

                    </div>
                </div>
                <div className="row pt-5 mt-5 pb-5">
                    <div className="col-md-3">
                        <div className="buynft">
                            <img className="w-100 fourimages" src={first}></img>
                            {/* <h6 className="pt-5">0.02 Eth</h6>
                            <p>BUY NFT</p> */}
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className="buynft pt-5 mt-5">
                            <img className="w-100 fourimages" src={second}></img>
                            {/* <h6 className="pt-5">0.02 Eth</h6>
                            <p>BUY NFT</p> */}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="buynft">
                            <img className="w-100 fourimages" src={third}></img>
                            {/* <h6 className="pt-5">0.02 Eth</h6>
                            <p>BUY NFT</p> */}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="buynft pt-5 mt-5">
                            <img className="w-100 fourimages" src={forth}></img>
                            {/* <h6 className="pt-5 ">0.02 Eth</h6>
                            <p>BUY NFT</p> */}
                        </div>
                    </div>
                </div>
                <div className="btn1">
                    <JoinButton
                        text="Join Our Community"
                    />
                </div>
            </div>
        </div>
    )
}
export default Promise;